module.exports = __webpack_public_path__ + "img/percayso-logo.f8fbbe40.svg";